module.exports = __webpack_public_path__ + "static/media/derp-scroll.519d9937.png";